import { Directive, HostListener, Input } from '@angular/core';

/**
 * Polyfill for browsers (or JSDOM) that do not support [form] attribute of submit and reset controls
 */
@Directive({
    selector: `
        input[type=submit][form],
        button[type=submit][form],
        input[type=reset][form],
        button[type=reset][form]
    `,
})
export class FormAttributeDirective {

    @Input('form') formId: string;

    @Input('type') eventType: 'submit' | 'reset';

    @HostListener('click', ['$event'])
    onClick(click: Event) {
        const form = document.getElementById(this.formId);
        if (form) {
            click.preventDefault();
            form.dispatchEvent(new Event(this.eventType, { bubbles: true, cancelable: true }));
        }
    }
}
